// extracted by mini-css-extract-plugin
export default {"login":"styles_login__GdcJ1","window":"styles_window__Yi5Tc"};